module.exports = __webpack_public_path__ + "static/img/pic_01@2x.b8c58f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_01@2x.png
// module id = ns0Z
// module chunks = 2